import { createEmptyFilters, hasLength } from "./HelperFunction";
import { MONTHLY_PREMIUM_ID } from "./constants/payrollConstants";

export function buildFilterClause(type, value, field, currentFilter = {}) {
  const where = {};

  switch (type) {
    case "Pointer":
      if (Object.keys(value).length > 0) {
        where[field] = { id: value.id };
      }
      break;
    case "Relation": {
      const relationField = field === "payrollType" ? "payItem" : "payrollType";
      const existingQuery =
        currentFilter?.[relationField]?.payrollClassification?.$elemMatch || {};

      where.payrollClassification = {
        $elemMatch: {
          ...existingQuery,
          [`${field}.id`]: value.id,
        },
      };
      break;
    }
    case "StringNotEqual":
      where[field] = { $ne: value };
      break;
    case "BooleanNotTrue":
      where[field] = { $ne: true };
      break;
    default:
      where[field] = { $regex: value, $options: "i" };
  }

  return where;
}

export function buildFilters(currentFilter, nextFilters = {}, preserveKeys = []) {
  const preserved = preserveKeys.reduce((acc, key) => {
    if (currentFilter[key] && Object.keys(currentFilter[key]).length > 0) {
      acc[key] = currentFilter[key];
    }
    return acc;
  }, {});

  return { ...createEmptyFilters(), ...preserved, ...nextFilters };
}

export function selectedPayrollTypeFilter(payrollType) {
  if (!hasLength(payrollType) || payrollType.shouldClearFilters) {
    return null;
  }

  return {
    payrollClassification: {
      $elemMatch: { "payrollType.id": payrollType.id },
    },
  };
}

export function getFieldWhereClause(field, existingWhere, panelState) {
  const { payrollTypes, employmentType } = panelState;

  let additionalWhere = {};

  switch (field) {
    case "employmentType":
      if (payrollTypes?.value?.id) {
        additionalWhere = {
          $or: [
            { hiddenFor: { $exists: false } },
            { hiddenFor: { $size: 0 } },
            { hiddenFor: { $not: { $elemMatch: { id: payrollTypes?.value?.id } } } },
          ],
        };
      }
      break;

    case "payItems":
      if (payrollTypes?.value?.name !== "Special Payroll") {
        if (payrollTypes?.value?.id && employmentType?.value?.id) {
          additionalWhere = {
            showOnly: {
              payrollTypes: { $elemMatch: { id: payrollTypes?.value?.id } },
              employmentTypes: { $elemMatch: { id: employmentType?.value?.id } },
            },
          };
        }
      } else {
        additionalWhere = {
          $or: [{ id: MONTHLY_PREMIUM_ID }, { isIncentive: true }],
        };
      }
      break;

    default:
      break;
  }

  return { ...existingWhere, ...additionalWhere };
}
